export const testimonials = [
  {
    id: 't-1',
    name: '小雨',
    role: '旅行爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20simple%20female%20avatar%20portrait%20silhouette%2C%20minimal%20abstract%20style%2C%20earthy%20colors%2C%20clean%20background%2C%20artistic%20illustration&width=80&height=80&seq=test-1&orientation=squarish',
    content: '在蘑菇社区认识了三个一起旅行的伙伴，我们刚刚从川西自驾回来。感谢蘑菇社区让我找到了志同道合的朋友，让旅途不再孤单。',
    rating: 5,
  },
  {
    id: 't-2',
    name: '大雄',
    role: '科技产品评测师',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20simple%20male%20avatar%20portrait%20silhouette%2C%20minimal%20abstract%20style%2C%20earthy%20colors%2C%20clean%20background%2C%20artistic%20illustration&width=80&height=80&seq=test-2&orientation=squarish',
    content: '以前写的评测文章都没什么人看，自从在蘑菇社区发布后，每篇都有几百条互动评论。这里的用户真的很认真在交流和讨论，氛围太好了。',
    rating: 5,
  },
  {
    id: 't-3',
    name: '阿琳',
    role: '美食博主',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20simple%20female%20avatar%20portrait%20silhouette%2C%20minimal%20abstract%20style%2C%20earthy%20colors%2C%20clean%20background%2C%20artistic%20illustration&width=80&height=80&seq=test-3&orientation=squarish',
    content: '我分享的家常菜谱在美食圈子里获得了上千个赞！还有很多朋友跟做了之后回来反馈，这种互动让我特别有成就感。',
    rating: 5,
  },
  {
    id: 't-4',
    name: '老张',
    role: '健身达人',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20simple%20male%20avatar%20portrait%20silhouette%2C%20minimal%20abstract%20style%2C%20earthy%20colors%2C%20clean%20background%2C%20artistic%20illustration&width=80&height=80&seq=test-4&orientation=squarish',
    content: '在蘑菇社区的健身圈子里，大家一起打卡锻炼、互相监督。三个月下来，不仅身材变好了，还养成了健康的生活习惯。真心推荐给想开始健身的朋友。',
    rating: 5,
  },
];

export const stats = [
  { label: '活跃用户', value: '18万+', icon: 'ri-user-smile-line' },
  { label: '兴趣圈子', value: '6大类', icon: 'ri-group-line' },
  { label: '优质文章', value: '1.2万+', icon: 'ri-article-line' },
  { label: '日均互动', value: '5万+', icon: 'ri-chat-3-line' },
];